export function paramCase(str: string) {
  return (
    str
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
  );
}

export function slugify(str: string) {
  return (
    str
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '')
  );
}

export function snakeCase(str: string) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}
